import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment/moment';

export class CustomValidators {
  public static readonly PHONE_NUMBER_REGEX = '^[\\+\\d]?(?:[\\d-.\\s()]*)$';

  static password(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }
    
    if (value.length < 8 || !value.match('[a-z]') || !value.match('[A-Z]') || !value.match('\\d') || !value.match('[!@#$%^&*=_+-]')) {
      const res = { pattern: true };
      if (value.length < 8) res['minlength'] = true;
      if (!value.match('[a-z]') || !value.match('[A-Z]')) res['upperCase'] = true;
      if (!value.match('\\d')) res['number'] = true;
      if (!value.match('[!@#$%^&*=_+-]')) res['specialSymbol'] = true;
      return res;
    }
    return null;
  }

  static matchPassword(control: AbstractControl): ValidationErrors | null {
    if (control.parent) {
      return control.value === control.parent.get('password').value ? null : {ConfirmPassword: true};
    }
    return null;
  }

  static age(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }
    const age = moment().diff(value, 'years');
    if (age > 99) {
      return {age99: true};
    }
    return age < 13 ? {age13: true} : null;
  }
}
